import Vue from 'vue'
import GbUI from '@geekbrains/geekbrains-ui-kit'

Vue.use(GbUI)
